'use client';

interface StatItem {
  value: string | number;
  label: string;
  color?: string;
  onPress?: () => void;
}

interface StatsRowProps {
  items: StatItem[];
}

export function StatsRow({ items }: StatsRowProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {items.map((item, i) => {
        const Tag = item.onPress ? 'button' : 'div';
        return (
        <Tag
          key={i}
          onClick={item.onPress}
          className="text-center"
          style={{
            background: 'var(--pub-surface-2)',
            border: '1px solid var(--pub-border)',
            borderRadius: 14,
            padding: '12px 10px',
            transition: 'background 0.3s, border-color 0.3s',
            cursor: item.onPress ? 'pointer' : 'default',
          }}
        >
          <div
            style={{
              fontFamily: 'var(--font-pub-display)',
              fontSize: 17,
              fontWeight: 700,
              color: item.color || 'var(--pub-text-primary)',
              letterSpacing: '-0.02em',
            }}
          >
            {item.value}
          </div>
          <div
            style={{
              fontFamily: 'var(--font-pub-mono)',
              fontSize: 8,
              color: 'var(--pub-text-muted)',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginTop: 3,
            }}
          >
            {item.label}
          </div>
          {item.onPress && (
            <div style={{ fontFamily: 'var(--font-pub-mono)', fontSize: 7, color: 'var(--pub-text-muted)', marginTop: 2, letterSpacing: '0.06em' }}>
              TAP TO VIEW
            </div>
          )}
        </Tag>
        );
      })}
    </div>
  );
}
